import Lenis from 'lenis';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { initAnimations } from './globalAnimations';

gsap.registerPlugin(ScrollTrigger);

// Smooth scroll

export const lenis = new Lenis({
  lerp: 0.075,
  wheelMultiplier: 1.3,
  touchMultiplier: 1.3,
    prevent: (node) =>
        node.closest('.select2-dropdown'),
})

lenis.on('scroll', ScrollTrigger.update);

gsap.ticker.add((time) => {
  lenis.raf(time * 1000);
});

export const initAnim = () => {
  // Animation for mobile menu
  function preventPageScrolling () {
    // Prevent page scrolling on press space
    window.addEventListener('keydown', (event) => {
      const isEditable = ['INPUT', 'TEXTAREA'].includes(event.target.tagName) || event.target.isContentEditable;

      if (!isEditable  && event.code === 'Space') {
        event.preventDefault();
      }
    });
  }

  function animatePreloader() {
    const preloader = document.querySelector(".preloader");

    if(preloader) {
      const paths = preloader.querySelectorAll("#preloader-svg path");

      paths.forEach((path) => {
        const length = path.getTotalLength();
        path.style.strokeDasharray = length;
        path.style.strokeDashoffset = length;
        path.style.visibility = "hidden";
      });

      paths.forEach((path, index) => {
        const isLast = index === paths.length - 1;
        gsap.to(path, {
          strokeDashoffset: 0,
          duration: 1,
          delay: index * 0.1,
          ease: "power1.inOut",
          onStart: () => {
            path.style.visibility = "visible";
          },
          ...(isLast && {
            onComplete: () => {
              preloader.classList.add("loaded_hiding");
            },
          }),
        });
      });
    }
  }

  initAnimations()

  return {
    init() {
      preventPageScrolling();
      animatePreloader();
    },
  }
};
